export default {
  namespaced: true,

  state: {
    token: ''
  },

  getters: {
    currentKitToken: (state) => state.token
  },

  mutations: {
    setKitToken(state, { kitToken }) {
      state.token = kitToken
    },

    resetState(state) {
      state.token = ''
    }
  },

  actions: {
    setKitToken({ commit, state }, kitToken) {
      commit('setKitToken', { kitToken })
    }
  }
}
